<template>
  <div class="" style="padding: 0; height: 250px; width: 90%">
    <div
      class=""
      id="waterAffairsLeftCenter"
      @mouseenter="clearDispatchTimer"
      @mouseleave="setDispatchTimer"
      style="height: 100%; width: 100%"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
export default {
  data() {
    return {
      interVal: "",
      myChart: null,
      app: {
        currentIndex: -1,
      },
      dispatchTimer: null,
      dataLen: null,
    };
  },
  mounted() {
    // this.requestData(500)
    this.init();
  },
  methods: {
    requestData(number, area, tulongNum, beforeMoney, afterMoney) {
      this.$request(
        "center/newService1/farmLines?num=" +
          number +
          "&area=" +
          area +
          "&tulongNum=" +
          tulongNum +
          "&beforeMoney=" +
          beforeMoney +
          "&afterMoney=" +
          afterMoney
      ).then((res) => {
        if (this.myChart) {
          clearInterval(this.dispatchTimer);
          this.myChart.clear();
        }
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].type == 1) {
            this.init(res.data[i].list);
          }
        }
      });
    },
    init(pageData, type) {
      let that = this;
      that.myChart = echarts.init(
        document.getElementById("waterAffairsLeftCenter")
      );

      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        that.myChart.resize();
      });

      const PIE_DATA = [
        { name: "正常", value: 907, proportion: "90%" },
        { name: "运行中", value: 227, proportion: "20%" },
        { name: "维护中", value: 63, proportion: "2%" },
        { name: "告警", value: 38, proportion: "1%" },
        { name: "故障", value: 25, proportion: "1%" },
      ];
      let count = 1260;
      const HIDDEN_OPTIONS = {
        normal: { show: false },
        emphasis: { show: false },
      };

      const BASE_PIE_CONFIG = {
        center: ["40%", "50%"],
        type: "pie",
        label: HIDDEN_OPTIONS,
        labelLine: HIDDEN_OPTIONS,
        padAngle: 3,
      };

      var option = {
        title: {
          subtext: "水务分布",
          textStyle: { color: "#FDC200", fontSize: 38 },
          subtextStyle: { fontSize: 18, color: "#fff" },
          textAlign: "center",
          textVerticalAlign: "middle",
          x: "38%",
          y: "43%",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          right: 10,
          top: "center",
          orient: "vertical",
          itemGap: 15,
          textStyle: { color: "#f2f2f2" },
          formatter: (params) => {
            const item = PIE_DATA.find((i) => i.name === params);
            return `${params} ${((item.value / count) * 100).toFixed(1)}%`;
          },
          data: PIE_DATA,
        },
        series: [
          // 主饼图
          {
            ...BASE_PIE_CONFIG,
            color: ["#23BE72", "#00D1C8", "#7D5AFB", "#F9DA4F", "#E32929"],
            radius: ["64%", "84%"],
            data: PIE_DATA,
          },
          // 边框系列
          // 内边框1
          {
            ...BASE_PIE_CONFIG,
            silent: true,
            silent: true,
            radius: ["44%", "58%"],
            startAngle: -30,
            endAngle: -10,
            data: [{ value: 1, itemStyle: { color: "#0C3D6B" } }],
          },
          // 内边框2
          {
            ...BASE_PIE_CONFIG,
            silent: true,
            radius: ["47%", "55%"],
            data: [{ value: 1, itemStyle: { color: "#0C3D6B" } }],
          },
          // 内边框3
          {
            ...BASE_PIE_CONFIG,
            silent: true,
            radius: ["60%", "62%"],
            data: [{ value: 0, itemStyle: { color: "#0C3D6B" } }],
          },
          // 外边框
          {
            ...BASE_PIE_CONFIG,
            silent: true,
            name: "外边框",
            radius: ["80%", "82%"],
            data: [{ value: 0, itemStyle: { color: "#0C3D6B" } }],
          },
          // 刻度盘
          {
            name: "刻度盘",
            type: "gauge",
            min: 0,
            max: 100,
            radius: "105%",
            center: ["40%", "50%"],
            startAngle: 0,
            endAngle: 360,
            axisLine: { show: false },
            silent: true,
            splitLine: { show: false },
            axisLabel: { show: false },
            pointer: { show: false },
          },
        ],
      };

      //   that.dataLen = option.series[0].data.length;
      that.dispatchActions();

      that.myChart.setOption(option);
      //   this.interVal = setInterval(function () {
      //     that.myChart.clear();
      //     that.myChart.setOption(option);
      //   }, 240000);
      // 20000
    },
    dispatchActions() {
      let that = this;
      that.dispatchTimer = setInterval(function () {
        // 取消之前高亮的图形
        that.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
        //console.log(app.currentIndex);
        // 高亮当前图形
        that.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        // 显示 tooltip
        that.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
      }, 3000);
    },
    clearDispatchTimer() {
      clearInterval(this.dispatchTimer);
    },
    setDispatchTimer() {
      this.dispatchActions();
    },
  },
  destroyed() {
    clearInterval(this.interVal);
  },
};
</script>

<style>
</style>